export default __webpack_public_path__ + "static/media/0026.e605794b.WAV";